<template>
  <section id="contact" class="contact-section">
    <div class="contact-bg">
      <div class="bg-grid"></div>
      <div class="bg-orb-1"></div>
      <div class="bg-orb-2"></div>
    </div>

    <div class="container">
      <div class="section-title" style="color:#fff;">
        <div class="en-label" style="color:#00c9a7;">{{ $t('contact.eyebrow') }}</div>
        <h2 style="color:#fff;">{{ $t('contact.title') }}</h2>
        <p style="color:rgba(255,255,255,.65);">{{ $t('contact.desc') }}</p>
      </div>

      <div class="contact-panel">
        <div class="info-card">
          <div class="info-item" v-for="info in contactInfo" :key="info.id">
            <div class="info-icon">
              <i :class="info.icon"></i>
            </div>
            <div>
              <div class="info-label">{{ info.label }}</div>
              <div class="info-value">{{ info.value }}</div>
            </div>
          </div>
        </div>

        <div class="offices">
          <h4>{{ $t('contact.officeTitle') }}</h4>
          <div class="office-tags">
            <el-tag v-for="city in cities" :key="city" class="city-tag" effect="plain">
              {{ city }}
            </el-tag>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ContactSection',
  computed: {
    contactInfo() {
      return this.$tm('contact.info')
    },
    cities() {
      return this.$tm('contact.cities')
    }
  }
}
</script>

<style lang="less" scoped>
.contact-section {
  padding: 120px 0 150px;
  position: relative;
  overflow: hidden;
}

.contact-bg {
  position: absolute;
  inset: 0;
  background: linear-gradient(135deg,#050d1a 0%,#0a1628 50%,#0d2952 100%);
}

.bg-grid {
  position: absolute;
  inset: 0;
  background-image:
    linear-gradient(rgba(0,201,167,.04) 1px, transparent 1px),
    linear-gradient(90deg, rgba(0,201,167,.04) 1px, transparent 1px);
  background-size: 60px 60px;
}

.bg-orb-1 {
  position: absolute;
  width: 500px;
  height: 500px;
  top: -150px;
  right: -100px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(108,92,231,.15), transparent 70%);
  filter: blur(60px);
}

.bg-orb-2 {
  position: absolute;
  width: 400px;
  height: 400px;
  bottom: -100px;
  left: -50px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(0,201,167,.12), transparent 70%);
  filter: blur(60px);
}

.container {
  position: relative;
  z-index: 1;
}

.contact-panel {
  max-width: 980px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: minmax(0, 1.15fr) minmax(0, .85fr);
  gap: 24px;
  align-items: stretch;
}

.info-card,
.offices {
  background: rgba(255,255,255,.05);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255,255,255,.1);
  border-radius: var(--radius-lg);
}

.info-card {
  padding: 28px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  justify-content: center;
}

.info-item {
  display: flex;
  align-items: flex-start;
  gap: 14px;
}

.info-icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: rgba(0,201,167,.15);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #00c9a7;
  font-size: 18px;
  flex-shrink: 0;
}

.info-label {
  font-size: 11px;
  color: rgba(255,255,255,.4);
  margin-bottom: 3px;
}

.info-value {
  font-size: 13px;
  color: rgba(255,255,255,.85);
  line-height: 1.5;
}

.offices {
  padding: 24px 28px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.offices h4 {
  font-size: 14px;
  font-weight: 700;
  color: rgba(255,255,255,.8);
  margin-bottom: 14px;
}

.office-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.city-tag {
  background: rgba(10,92,138,.2) !important;
  color: #74b9ff !important;
  border-color: rgba(116,185,255,.2) !important;
  border-radius: 20px !important;
}

@media (max-width: 900px) {
  .contact-panel {
    max-width: 560px;
    grid-template-columns: 1fr;
    gap: 20px;
  }
}
</style>
